import { inject, Signal } from '@angular/core';
import { ParserService } from '@app/services/parser.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { combineLatest, switchMap } from 'rxjs';

export default function parsed<T>(
  value: Signal<T>,
  context: Signal<Record<string, unknown>>
) {
  const parser = inject(ParserService);
  const value$ = toObservable(value);
  const context$ = toObservable(context);
  return toSignal(
    combineLatest([value$, context$]).pipe(
      switchMap(([v, c]) => parser.parse(v, { context: c }))
    )
  );
}
